module.exports = __webpack_public_path__ + "static/media/explode.54257beb.png";


//////////////////
// WEBPACK FOOTER
// ./src/game/assets/explode.png
// module id = 77
// module chunks = 0